module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921015649_T.c87f54f6.jpg";